/**
 * Converts a flat object with dot-notation keys into a nested object.
 * e.g. { "contact.email": "a", "name": "b" } → { contact: { email: "a" }, name: "b" }
 */
export default function toNestedObject(flat: Record<string, any>): Record<string, any> {
    const result: Record<string, any> = {};
    for (const [key, value] of Object.entries(flat)) {
        const parts = key.split(".");
        let obj = result;
        for (let i = 0; i < parts.length - 1; i++) {
            if (obj[parts[i]] === undefined || typeof obj[parts[i]] !== "object") {
                obj[parts[i]] = {};
            }
            obj = obj[parts[i]];
        }
        obj[parts[parts.length - 1]] = value;
    }
    return result;
}
